// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__mcFCS","backButton":"styles_backButton__PY5a_","disabledBackButton":"styles_disabledBackButton__7AIvI","angleRight":"styles_angleRight__tEEKS"};